import * as React from 'react'
import { css } from '@emotion/react'

type Props = {
  color?: string
}

export const Loader: React.FC<Props> = ({ color = '#999' }) => {
  return (
    <div
      css={css`
        height: 0;
        width: 0;
        padding: 10px;
        border: 3px solid ${color};
        border-right-color: transparent;
        opacity: 0.5;
        border-radius: 22px;
        animation: rotate 1s infinite ease-in-out;
        @keyframes rotate {
          100% {
            -webkit-transform: rotate(360deg);
          }
        }
      `}
    />
  )
}
